<template>
    <div  class="page">
     
            <div class="weui-tab">
                <div class="weui-navbar2">
                    <div v-for="(item, index) in tabs" :key="index" @click="clickThis(index)"
                        :class="['weui-navbar__item2', activeIndex === index ? 'weui-bar__item_on2' : '']">
                        {{ item }}
                    </div>
                </div>
            </div>

            <div class="weui-tab__panel tab0" v-if="activeIndex === 0">
                <coupon-bar v-for="(item, index) in couponListOn" :key="index" :coupon="item.couponInfo"
                    :data-index="index">
                    <t-button size="extra-small"  
                        :data-index="index" style="color:black;font-weight: normal;" @click="useThisCoupon(index)">
                        使用
                    </t-button>
                </coupon-bar>
            </div>

            <div class="weui-tab__panel tab1" v-if="activeIndex === 1">
                <coupon-bar v-for="(item, index) in couponListOff" :key="index" :coupon="item.couponInfo"
                    :data-index="index" />
            </div>

            <div class="footBar">

                <t-button class="footBtn" theme="primary" @click="colseDialog">取消</t-button>
            </div>
         
    </div>
</template>

<script setup>
import { ref, getCurrentInstance, defineProps, defineEmits } from 'vue'
import couponBar from './coupon-bar.vue'
import { formatTime2 } from '@/utils'

// 定义 props
const props = defineProps({

    customerId: {
        type: String,
        default: ''
    },

    totalPrice: {
        type: Number,
        default: 0
    }, solidProductPrice: {
        type: Number,
        default: 0
    }, serviceProductPrice: {
        type: Number,
        default: 0
    }
})
const { proxy } = getCurrentInstance();
const app = proxy.$cloudbase;
const couponListOn = ref([]);
const couponListOff = ref([]);
// 定义 emits
const emit = defineEmits(['useCoupon','closeDialog'])

const tabs = ref(['可用', '不可用']);
// 响应式数据
const activeIndex = ref(0);

const colseDialog=() => {
    emit('closeDialog')
}
// 方法
const clickThis = (index) => {
    activeIndex.value = index
}


const loadCouponOn = async () => {
    let customerId = props.customerId;
    let now = new Date();
    let today = formatTime2(now);
    const db = app.database();
    const _ = db.command;
    let couponList = await db.collection("my_customer_coupon").where({
        'customerInfo._id': customerId,
        expireDate: _.gte(today),
        status: 1

    }).get().then(res => {

        return res.data;

    })

    let { totalPrice, solidProductPrice, serviceProductPrice } = props;
    couponList.map(item => {
        let { couponInfo } = item;
        let { couponType, reduceAmount, discount, productType, reachAmount } = couponInfo;
        let orderPrice = productType == 0 ? totalPrice : productType == 1 ? serviceProductPrice : solidProductPrice;
        if (couponType == 1 && orderPrice < reachAmount) {
            item.canUse = false;
            item.couponAmount = 0;
            return;
        }
        item.couponAmount = couponType == 1 ? reduceAmount : Math.round((100 - discount) * orderPrice / 100);
        item.canUse = true;

    })
    couponListOn.value = couponList.filter(item => { return item.canUse }),
    couponListOff.value = couponList.filter(item => { return !item.canUse })

};

const useThisCoupon = (index) => {

    let coupon = couponListOn.value[index];
    emit('useCoupon', coupon)
}

loadCouponOn();

</script>

<style scoped>
.page
 {
    height:70vh;
     padding-bottom: 60px;
     background-color: #f6f6f6;
}

 

.weui-tab__content {
    padding-top: 60px;
    text-align: center;
}

.weui-navbar2 {

    display: flex;
    justify-content: space-around;
}

.weui-navbar__item2 {

    color: gray;
    height: 18px;
    line-height: 18px;
    padding: 12px 15px;
    font-size: 14px;
    position: relative;

}

.weui-bar__item_on2 {

    color: rgb(83, 83, 83);
}

.weui-tab__panel {



    padding: 3vw 4vw;
    box-sizing: border-box;


}

.weui-bar__item_on2:after {
    content: "";

    position: absolute;

    bottom: 0;

    left: 35%;

    width: 30%;

    border: 2px solid rgb(83, 83, 83);
    border-radius: 1px;

    -webkit-transform: scaleY(0.5);

    transform: scaleY(0.5);

    -webkit-transform-origin: 0 0;

    transform-origin: 0 0;

    box-sizing: border-box;

}
.footBar{
    position:fixed;
    bottom:5vw;
    right: 5vw;
    width: 100vw;
    display: flex;
    justify-content: end;
}
/* 保留原有的样式类名 */
</style>